import React from 'react';
import styled, { css } from 'styled-components';
import CoreButton from 'gatsby-theme-core/src/components/button/index';
import Image from 'gatsby-theme-core/src/components/image';
import PhoneIcon from 'icons/src/Phone';
import Button from '../../button/index';
import HightlightBlock from '../highlights/blocks/block';
import Content from '../../content';

const CompanyBlock = ({
  className,
  company,
  columnWidth,
  title,
  justify,
  buttons,
  callButton,
  emailButton,
  planRouteButton,
  showPhonenumber = true,
  showEmail = true,
  showFax = true,
  showKvk = true,
  showIban = true,
  showBtw = true,
  showLabels = false,
}) => {
  const {
    street,
    houseNumber,
    postcode,
    city,
    tel,
    telWithCountryCode,
    tel2,
    tel2WithCountryCode,
    fax,
    email,
    kvk,
    btw,
    iban,
    labels,
  } = company;

  return (
    <HightlightBlock
      className={className}
      image={company.image}
    >
      <StyledContent textAlign={justify}>
        <h2>{title}</h2>
        <Grid $columnWidth={columnWidth}>
          <div>
            <strong>Adresgegevens</strong>
            <address>
              {`${street} ${houseNumber}`}
              <br />
              {postcode} {city}
            </address>
          </div>

          <div>
            <strong>Contact</strong>
            <p css="&& {margin-bottom: 0}">
              {showPhonenumber && tel && (
                <>
                  T: <a title={tel} href={`tel:${telWithCountryCode}`}>{tel}</a>
                  <br />
                </>
              )}
              {showPhonenumber && tel2 && (
                <>
                  T: <a title={tel2} href={`tel:${tel2WithCountryCode}`}>{tel2}</a>
                  <br />
                </>
              )}
              {showFax && fax && (
                <>
                  F: {fax}
                  <br />
                </>
              )}
              {showEmail && email && (
                <>
                  E: <a title={email} href={`mailto:${email}`}>{email}</a>
                </>
              )}
            </p>
          </div>
        </Grid>

        {(showKvk || showBtw || showIban) && (
          <p>
            {showKvk && kvk && (
              <>KvK: {kvk} <br /></>
            )}
            {showBtw && btw && (
              <>BTW: {btw} <br /></>
            )}
            {showIban && iban && (
              <>IBAN: {iban} <br /></>
            )}
          </p>
        )}
        {showLabels && labels?.length > 0 && (
          <LabelsGrid>
            {labels.map(({ id, image }) => (
              <Image key={id} image={image} width="40" height="auto" />
            ))}
          </LabelsGrid>
        )}
        <ButtonsGrid>
          {callButton && (
            <CoreButton
              primary
              href={`tel:${telWithCountryCode}`}
              prefixIcon={PhoneIcon}
            >
              Direct bellen
            </CoreButton>
          )}
          {emailButton && (
            <CoreButton
              primary={!callButton}
              link={callButton} // if second button, show as link
              href={`mailto:${email}`}
            >
              Direct mailen
            </CoreButton>
          )}
          {planRouteButton && (
            <CoreButton
              primary={!(callButton || emailButton)}
              link={callButton || emailButton} // if second (or third) button, show as link
              href={`https://www.google.nl/maps/dir//${encodeURIComponent(`${title},${street} ${houseNumber},${city}`)}`}
            >
              Plan route
            </CoreButton>
          )}
          {buttons?.length > 0 && buttons.map((button) => (
            <Button key={button.id} {...button} />
          ))}
        </ButtonsGrid>
      </StyledContent>
    </HightlightBlock>
  );
};

const ButtonsGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const LabelsGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const StyledContent = styled(Content)`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
  height: 100%;
  > *:last-child {
    margin-top: auto;
  }

  h2 {
    margin-bottom: 0.5rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 1rem;
  grid-template-columns: minmax(0, 1fr);

  ${({ $columnWidth }) => $columnWidth > 8 && css`
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
  `}

  address {
    line-height: 180%;
    font-weight: normal;
  }
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export default styled(CompanyBlock)``;
